import React from 'react';
import { ArrowUpIcon, ArrowDownIcon, ArrowUpDownIcon } from 'lucide-react';
import { SortDirection } from '../../hooks/useSortableData';
interface SortableHeaderProps {
  label: string;
  sortKey: string;
  currentDirection: SortDirection;
  onSort: (key: string) => void;
  className?: string;
  align?: 'left' | 'right' | 'center';
}
export function SortableHeader({
  label,
  sortKey,
  currentDirection,
  onSort,
  className = '',
  align = 'left'
}: SortableHeaderProps) {
  const alignClass = align === 'right' ? 'text-right justify-end' : align === 'center' ? 'text-center justify-center' : 'text-left';
  return <th className={`py-4 px-6 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider cursor-pointer select-none group hover:text-gray-700 dark:hover:text-gray-200 transition-colors ${alignClass} ${className}`} onClick={() => onSort(sortKey)} data-id="element-6471" data-mp="174c4hrfmlcem">
      <span className={`inline-flex items-center gap-1.5 ${align === 'right' ? 'flex-row-reverse' : ''}`} data-id="element-6472" data-mp="1b78mbfxcd4hi">
        {label}
        <span className="flex-shrink-0 w-3.5 h-3.5 flex items-center justify-center" data-id="element-6473" data-mp="1f2t02u2ih50o">
          {currentDirection === 'asc' ? <ArrowUpIcon className="w-3.5 h-3.5 text-teal-500" data-id="element-6474" data-mp="1k1cod14kusw7" /> : currentDirection === 'desc' ? <ArrowDownIcon className="w-3.5 h-3.5 text-teal-500" data-id="element-6475" data-mp="1oyw5c8sntjru" /> : <ArrowUpDownIcon className="w-3.5 h-3.5 text-gray-300 dark:text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-6476" data-mp="1tz0lfxpnochj" />}
        </span>
      </span>
    </th>;
}